export enum AuthUserPermissionsEnum {
  WRITE = 'write',
  READ = 'read',
  ADMIN = 'admin',
}
